import React, { useEffect, useState } from "react";
import axios from "axios";

export default function TimeList() {
  const [rows, setRows] = useState([]);

  const loadData = async () => {
    const res = await axios.get("http://localhost/myapp/api/fetch.php");
    setRows(res.data);
  };

  useEffect(() => { loadData(); }, []);

  const toggleStatus = async (heading, status) => {
    await axios.post("http://localhost/myapp/api/toggle-status.php", {
      heading,
      status: status ? 0 : 1,
    });
    loadData();
  };

  const deleteGroup = async (heading) => {
    if (!window.confirm("Delete this group?")) return;
    await axios.post("http://localhost/myapp/api/delete.php", { heading });
    loadData();
  };

  return (
    <table border="1" width="100%" cellPadding="10">
      <thead>
        <tr>
          <th>Heading</th>
          <th>Morning</th>
          <th>Evening</th>
          <th>Status</th>
          <th>Actions</th>
        </tr>
      </thead>

      <tbody>
        {rows.map((item, i) => (
          <tr key={i}>
            <td><b>{item.heading}</b></td>

            <td>
              {item.morning.map((m, idx) => (
                <div key={idx}>{m.time_value}</div>
              ))}
            </td>

            <td>
              {item.evening.map((e, idx) => (
                <div key={idx}>{e.time_value}</div>
              ))}
            </td>

            <td>
              <button onClick={() => toggleStatus(item.heading, item.status)}>
                {item.status ? "Enabled" : "Disabled"}
              </button>
            </td>

            <td>
              <button style={{marginRight:5}}>✏️ Edit</button>
              <button onClick={() => deleteGroup(item.heading)}>🗑️ Delete</button>
            </td>
          </tr>
        ))}
      </tbody>
    </table>
  );
}
